import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio Speaker Information" mdxType="Seo" />
    <h1 {...{
      "id": "speaker-information"
    }}>{`Speaker Information`}</h1>
    <h2 {...{
      "id": "video-recording-guidelines"
    }}>{`Video Recording Guidelines`}</h2>
    <p>{`Congratulations again on having your talk accepted for PyOhio 2021!
We’re truly thankful to have you as part of this unusual year of our
conference.`}</p>
    <p>{`This year, we are asking all speakers to deliver a prerecorded video of
their talks. This doc will walk you through the essentials.`}</p>
    <h3 {...{
      "id": "how-long-should-my-video-be"
    }}>{`How long should my video be?`}</h3>
    <p>{`For PyOhio 2021, we are doing a collection of short talks. To help keep
the event on track and running smoothly for all of our remote attendees,
we have tighter time requirements than in live events:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Lightning Talks`}</strong>{` should be `}<strong parentName="p">{`5 minutes ± 30 seconds`}</strong>{` in length.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Thunder Talks`}</strong>{` should be `}<strong parentName="p">{`10 minutes ± 30 seconds`}</strong>{` in length.`}</p>
      </li>
    </ul>
    <p>{`Please, please, please do not go over the maximum time for your talk! If
you go over time, we cannot guarantee that the entire talk will be
presented on the stream.`}</p>
    <h3 {...{
      "id": "what-format-should-my-video-be"
    }}>{`What format should my video be?`}</h3>
    <ul>
      <li parentName="ul">{`Format: H264 MP4`}</li>
      <li parentName="ul">{`Resolution: 1920x1080`}</li>
      <li parentName="ul">{`Frame rate: 30fps`}</li>
      <li parentName="ul">{`Audio: AAC (preferred) or MP3`}</li>
    </ul>
    <h3 {...{
      "id": "when-does-my-video-have-to-be-delivered-by"
    }}>{`When does my video have to be delivered by?`}</h3>
    <p>{`We would like to receive all videos by `}<strong parentName="p">{`23:59:59 EDT on Sunday, July
18`}</strong>{`. This will give us enough time to pre-screen and process them.`}</p>
    <p><strong parentName="p">{`If it looks like you will not be able to make that date, please
contact us at `}<a parentName="strong" {...{
          "href": "mailto:program@pyohio.org",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`program@pyohio.org`}</a></strong>{` as soon as possible to let us know!
This will help keep the program chair’s panic level under control. :-)`}</p>
    <h3 {...{
      "id": "how-should-i-deliver-my-video"
    }}>{`How should I deliver my video?`}</h3>
    <p>{`You have two choices for delivering your video:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Upload your video to the private Dropbox folder that will be
created for you`}</strong>{` (we’ll contact everyone separately by email with
the link to this folder)`}</li>
      <li parentName="ol"><strong parentName="li">{`Upload your video to your own cloud sharing service`}</strong>{` and send a
link to or share it with `}<strong parentName="li"><a parentName="strong" {...{
            "href": "mailto:program@pyohio.org",
            "target": "_blank",
            "rel": "nofollow noopener noreferrer"
          }}>{`program@pyohio.org`}</a></strong>{`; we’ll handle
downloading it from there.`}</li>
    </ol>
    <h3 {...{
      "id": "how-should-i-record-my-presentation"
    }}>{`How should I record my presentation?`}</h3>
    <p>{`There are lots of ways you might choose to record your presentation.
Here are some suggestions that we hope will be useful. Ultimately,
whatever path you choose will be fine as long as you can deliver a video
in the right format.`}</p>
    <h4 {...{
      "id": "recording-with-obs-studio"
    }}>{`Recording with OBS Studio`}</h4>
    <p>{`OBS Studio is a free, open-source tool used for capturing audio and
video; it runs on Mac OS, Windows, and Linux: `}<a parentName="p" {...{
        "href": "https://obsproject.com",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://obsproject.com`}</a></p>
    <p>{`Here’s a guide to capturing both your screen and webcam using OBS:
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=uL8BwstqiqE",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://www.youtube.com/watch?v=uL8BwstqiqE`}</a></p>
    <h4 {...{
      "id": "recording-with-screenshotapp"
    }}>{`Recording with Screenshot.app`}</h4>
    <p>{`Mac OS 10.15 can record videos of the screen with the Screenshot app.
Here’s a guide to recording your screen with a voiceover in Mac OS 10.15
/ Catalina: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=6nn86t9955Y",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://www.youtube.com/watch?v=6nn86t9955Y`}</a></p>
    <h4 {...{
      "id": "recording-with-keynote"
    }}>{`Recording with Keynote`}</h4>
    <p>{`Apple’s Keynote can create videos with voiceover narration. Here’s a
guide to creating a video with voiceover narration using just Keynote:
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=C6e2ZtHnimA",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://www.youtube.com/watch?v=C6e2ZtHnimA`}</a></p>
    <p>{`Here’s a guide to creating a video with Keynote and combining it with a
webcam recording in iMovie:
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=yRnANp2kS3c",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://www.youtube.com/watch?v=yRnANp2kS3c`}</a></p>
    <h4 {...{
      "id": "recording-with-powerpoint"
    }}>{`Recording with PowerPoint`}</h4>
    <p>{`PowerPoint can also create videos of presentations, optionally including
video from a webcam. Here’s a guide to creating a video with PowerPoint:
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=pHXRuJEsN7M",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`https://www.youtube.com/watch?v=pHXRuJEsN7M`}</a></p>
    <h4 {...{
      "id": "other-tools"
    }}>{`Other Tools`}</h4>
    <p>{`Other tools you might choose include Elgato and Camtasia. If you have
recommendations to share with other presenters, let us know and we’ll
update this list.`}</p>
    <h3 {...{
      "id": "advice"
    }}>{`Advice`}</h3>
    <p>{`This is going to be a new and different experience for many speakers.
Thank you for your courage! Here are some thoughts we’ve had that might
be helpful as you prepare your video.`}</p>
    <h4 {...{
      "id": "practice-first"
    }}>{`Practice First`}</h4>
    <p>{`We `}<strong parentName="p">{`strongly recommend`}</strong>{` that whatever path you take for recording, you
should `}<strong parentName="p">{`practice recording before doing your presentation “for real”`}</strong>{`.
This way you can get comfortable with your choice of tools.`}</p>
    <h4 {...{
      "id": "have-a-script"
    }}>{`Have a Script`}</h4>
    <p>{`Have solid notes or a script that you can read from as you record your
presentation. It can be a lot harder to be impromptu or to ad lib for a
recording than it is to do so in a live room. Having a script of some
kind will help prevent you from stumbling or freezing up (things your
program chair is prone to do whenever doing voiceover work).`}</p>
    <h4 {...{
      "id": "maybe-record-in-segments"
    }}>{`Maybe Record in Segments`}</h4>
    <p>{`Delivering your presentation to a computer can feel quite different from
speaking to a roomful of live attendees. You may find it valuable to
record your presentation in shorter segments and assemble them using
your favorite video editor.`}</p>
    <h4 {...{
      "id": "live-coding-beware-keyboard-sounds"
    }}>{`Live Coding? Beware Keyboard Sounds!`}</h4>
    <p>{`If you are live coding, using your computer’s built-in microphone may
pick up the sound of typing, which can be distracting for your audience.
We recommend using an external microphone or headset, or using an
external keyboard. `}<strong parentName="p">{`Please review the audio of your recording before
submitting it!`}</strong></p>
    <h3 {...{
      "id": "speakers"
    }}>{`Speakers`}</h3>
    <p>{`PyOhio is dedicated to featuring a diverse and inclusive speaker lineup.`}</p>
    <p><strong parentName="p">{`All speakers will be expected to have read and adhere to the
conference `}<a parentName="strong" {...{
          "href": "/2021/conduct"
        }}>{`Code of Conduct`}</a>{`. In particular for
speakers: slide contents and spoken material should be appropriate for a
professional audience including people of many different backgrounds.
Sexual language and imagery is not appropriate, and neither are language
or imagery that denigrate or demean people based on race, gender,
religion, sexual orientation, physical appearance, disability, or body
size.`}</strong></p>
    <p>{`We will make every effort to provide accommodations for speakers and
attendees of all abilities---all we ask is that you let us know so we
can prepare accordingly.`}</p>
    <p>{`PyOhio is a conference in support of the local programmer community. We
aim to feature a mix of local and non-local speakers to offer a program
with broad appeal.`}</p>
    <h3 {...{
      "id": "resources"
    }}>{`Resources`}</h3>
    <p>{`This `}<a parentName="p" {...{
        "href": "https://github.com/vmbrasseur/Public_Speaking",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`public speaking
repository`}</a>{`, maintained
by `}<a parentName="p" {...{
        "href": "https://twitter.com/vmbrasseur",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`VM Brasseur`}</a>{`, has many useful
resources to help you polish your proposals and talks.`}</p>
    <p>{`You may review prior years’ talks for examples:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.pyohio.org/2020/events/talks/",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2020 Talks Listing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/playlist?list=PL2k6bbM_wgjtGSzPXzUzP3AfVO-o4imbB",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2020
Videos`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.pyohio.org/2019/events/talks/",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2019 Talks`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.pyohio.org/2019/events/tutorials/",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`2019 Tutorials`}</a></li>
    </ul>
    <h3 {...{
      "id": "questions"
    }}>{`Questions?`}</h3>
    <p>{`Email us at `}<a parentName="p" {...{
        "href": "mailto:program@pyohio.org",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`program@pyohio.org`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      